// src/assets/icons/MarketValue.jsx
import React from 'react';

const MarketValue = ({ color = "white", opacity = 0.7 }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6191 4.84778C9.21205 4.35154 7.58282 4.66613 6.45738 5.79157C4.89528 7.35367 4.89528 9.88633 6.45738 11.4484C7.58282 12.5739 9.21205 12.8885 10.6191 12.3922M4.61914 7.28667H9.28581M4.61914 9.95333H9.28581M16.6191 8.62C16.6191 13.0383 13.0374 16.62 8.61914 16.62C4.20086 16.62 0.619141 13.0383 0.619141 8.62C0.619141 4.20172 4.20086 0.619999 8.61914 0.619999C13.0374 0.619999 16.6191 4.20172 16.6191 8.62Z" stroke={color} strokeOpacity={opacity} strokeWidth="1.24" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default MarketValue;
